import * as Immutable from 'immutable';
import { combineReducers } from 'redux-immutable';
import UserDataStore from '../_stores/UserDataStore';
import { UserDataAction, UserDataActionType } from '../_actions/UserDataActions';
import UserPrefsReducer from './UserPrefsReducer';
import UserSecurityReducer from './UserSecurityReducer';
import UserAddressesReducer from './UserAddressesReducer';
import UserCreditCardsReducer from './UserCreditCardsReducer';
import UserCartReducer from './UserCartReducer';
import { PaginationItem } from '../_stores/PaginationStore';
import { UserPatternStore } from '../_stores/UserPatternsStore';
import UserCartStore, { ShippingType } from '../_stores/UserCartStore';
import { UserImageStore } from '../_stores/UserImagesStore';
import { AjaxActionStart, AjaxActionStartType, AjaxActionEnd, AjaxActionEndType } from '../../Common/_actions/AjaxAction';
import { Price } from '../../UIData/_stores/UIDataStore';
import { AccountAction, AccountActionType } from '../_actions/UserAccountActions';

const UserDataReducer = (store:UserDataStore = new UserDataStore(), action: AccountAction | UserDataAction | AjaxActionStart | AjaxActionEnd):UserDataStore => {
	switch (action.type) {
		case UserDataActionType.SetPaginationData:
			let list = getItemList(action.data.dataType);
			if (list) {
				Object.keys(action.data.items).forEach((itemId) => {
					let item = action.data.items[itemId];
					let itemStore:Immutable.Record<any> = null;
					if(action.data.dataType == "orders") {
						itemStore = new UserCartStore(item);
					} else {
						itemStore = getItem(action.data.dataType);
						Object.keys(item).forEach((itemKey) => {
							itemStore = itemStore.set(itemKey, item[itemKey]);
						});
					}
					let id = item.id || itemId;
					list = list.set(id, itemStore);

				});
			}
			store = store.withMutations(store => {
				store.setIn([action.data.dataType, 'total'], action.data.totalItems);
				store.setIn([action.data.dataType, 'items'], list);
				store.setIn([action.data.dataType, 'valid'], true);
			});
		break;

		case UserDataActionType.InvalidatePaginationData:
			store = store.setIn([action.name, 'valid'], false);
		break;

		case UserDataActionType.EditUserLoggedIn:
			store = store.set('loggedIn', action.status);
		break;

		case UserDataActionType.EditUserValidated:
			store = store.set('validated', action.valid);
		break;

		case UserDataActionType.EditUserFetched:
			store = store.set('fetched', action.fetched);
		break;

		case AccountActionType.EditUserCurrentOrder:
			store = store.set('currentOrder', new UserCartStore(action.order));
		break;

		case AccountActionType.RemoveAccountData:
			store = new UserDataStore();
		break;

		case AjaxActionStartType:
		case AjaxActionEndType:
			let type = getKeyFromAjaxUrl(action.url);
			if(!type) break;
			let loading = action.type == AjaxActionStartType;
			store = store.setIn([type, 'loading'], loading);
	}

	return combineReducers({
		fetched: (store) => store,
		loggedIn: (store) => store,
		validated: (store) => store,
		userAddresses: UserAddressesReducer,
		userCart: UserCartReducer,
		userCreditCards: UserCreditCardsReducer,
		userPrefs: UserPrefsReducer,
		userSecurity: UserSecurityReducer,
		patterns: (store) => store,
		orders: (store) => store,
		images: (store) => store,
		currentOrder: (store) => store,
	})(store, action) as UserDataStore;
}

function getItemList(key:string):Immutable.OrderedMap<string, any>{
	switch(key) {
		case "patterns"	: return Immutable.OrderedMap<string, UserPatternStore>()
		case "orders"	: return Immutable.OrderedMap<string, UserCartStore>()
		case "images"	: return Immutable.OrderedMap<string, UserImageStore>()
	}
}

function getItem(key:string):Immutable.Record<any> {
	switch(key) {
		case "patterns"	: return new UserPatternStore()
		case "orders"	: return new UserCartStore()
		case "images"	: return new UserImageStore()
	}
}

function getKeyType(key:string) {
	if([
		'subtotal',
		'shipping',
		'taxes',
		'discount',
		'total',
		'price',
	].indexOf(key) !== -1) return 'price';

	else return 'any';
}

function getKeyFromAjaxUrl(url:string):string {
	let valid = url.indexOf('ajax/user/') !== -1 && url.indexOf('/fetch') !== -1;
	if(!valid) return '';
	return url.split('ajax/user/')[1].split('/fetch')[0];
}

export default UserDataReducer;